module.exports = __webpack_public_path__ + "static/media/atypical-patterns.8e334e6d.png";